
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../../util';
import DropZone from '../../../dropzone/DropZone';
import Spinner from '../../../util/Spinner';

declare var window: WindowType;

@Component({
  name: 'ConvertModal',
  components: {
    DropZone,
    Spinner,
  },
})
export default class ConvertModal extends Vue {
  isUploading: boolean = false;

  get dropzoneUrl(): string {
    return window.application.baseUrl + 'api/v1/surveys/import';
  }

  get uid(): string {
    return (this as any)._uid;
  }

  onUploaded(event: any): void {
    this.isUploading = false;
    this.$emit('imported', event);
  }

  public open(): void {
    this.isUploading = false;
    $(this.$refs.convertModal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.convertModal!).modal('hide');
  }
}
